import { useTranslation } from 'react-i18next';
import { useStore } from 'context/StoreContext';
import Container from './Container';
import { AlertIcon } from './icons';

/**
 * Shown only when the shop profile could not be loaded. Honest and calm: says
 * what is happening and offers a retry.
 */
export default function ApiStatusBanner() {
  const { t } = useTranslation();
  const { isUnavailable, reload } = useStore();
  if (!isUnavailable) return null;

  return (
    <div role="status" className="border-b border-border bg-surface-alt text-ink">
      <Container className="flex flex-col gap-3 py-3 sm:flex-row sm:items-center">
        <AlertIcon className="hidden h-5 w-5 shrink-0 sm:block" />
        <p className="flex-1 text-sm">
          <strong className="font-semibold">{t('status.unavailableTitle')}</strong> {t('status.unavailableBody')}
        </p>
        <button
          type="button"
          onClick={reload}
          className="self-start text-sm font-semibold underline underline-offset-4 sm:self-auto"
        >
          {t('status.retry')}
        </button>
      </Container>
    </div>
  );
}
